import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Step = { title: string; body: string };

const STEPS: ReadonlyArray<Step> = [
  {
    title: 'Définis ingrédients & recettes',
    body: 'Saisis tes ingrédients avec leur unité d\'achat et leur coût. Compose chaque cocktail : 50 ml de rhum, 30 ml de citron… Velko calcule le coût et le pour cost %.',
  },
  {
    title: 'Vends — la conso se déduit',
    body: 'À chaque vente d\'un produit avec recette, les ingrédients sont décomptés automatiquement du stock. Même hors ligne, au comptoir, sans rien faire de plus.',
  },
  {
    title: 'Compte à l\'aveugle',
    body: 'En fin de service, ton équipe compte le stock réel sans voir le théorique. Pas de triche possible : les chiffres ne sont pas « arrangés » d\'avance.',
  },
  {
    title: 'Lis l\'écart en F CFA',
    body: 'Velko compare le théorique au réel et chiffre l\'écart en millilitres et en francs. Tu sais exactement quel ingrédient fuit, et combien ça te coûte.',
  },
];

export default function BarHowItWorksV2() {
  return (
    <section className="bg-paper py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Comment ça marche</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          Quatre étapes. <span className="underline-lime">Zéro tableur.</span>
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <div
              key={step.title}
              className="flex flex-col gap-4 border-2 border-charcoal-800 bg-white p-6 shadow-neobrutal-4"
            >
              <div className="flex items-center gap-3">
                <span
                  className="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-charcoal-800 bg-lime-500 font-marketing-display text-[18px] font-bold text-charcoal-800"
                  aria-hidden="true"
                >
                  {i + 1}
                </span>
                {i < STEPS.length - 1 && (
                  <span className="hidden h-px flex-1 bg-charcoal-200 lg:block" aria-hidden="true" />
                )}
              </div>
              <h3 className="font-marketing-display text-[18px] font-bold leading-[1.18] tracking-[-0.01em] text-charcoal-800">
                {step.title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-600">
                {step.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
